import { atom } from '~/observers/jotai'

export const menuStateAtom = atom<boolean>(false)
